import Vue from  'vue';


export default {

    created()
    {

        // this.eventHub.$on('page:unload', this.fadeIn.bind(this))
        // this.eventHub.$on('page:change', this.onDataSuccess.bind(this))
        // this.eventHub.$on('page:loaded', this.fadeOut.bind(this))
    },

    methods: {

        /*fadeIn()
        {
            this.$el.classList.remove('u-opacity-10')
            this.$el.classList.remove('u-hide')
            this.$el.classList.add('u-opacity-0')

            // hack repaint for chrome
            window.scrollY
            this.$el.classList.add('u-opacity-10')


            clearTimeout(this._to)
            this._to = setTimeout( this.onOpaque.bind(this), 1000 )
        },

        fadeOut()
        {
            this.$el.classList.remove('u-opacity-10')
            this.$el.classList.add('u-opacity-0')

            clearTimeout(this._to)
            this._to = setTimeout( this.onTransparent.bind(this), 1000 )
        },

        onOpaque()
        {

        },

        onTransparent()
        {
            this.$el.classList.add('u-hide')
        }*/
    }

}